<template>
  <div class="finance-quote">
    <div v-for="option in options" :key="option">
      <input
        :id="option"
        type="radio"
        :name="option"
        :value="option"
        class="finance-quote__option"
      />
      <label
        :class="[
          'finance-quote__label',
          {
            'finance-quote__label--active': activeOption === option,
            'finance-quote__label--disabled':
              disablePCP && option === options.PCP
          }
        ]"
        :for="option"
        @click="$emit('paymentTypeChange', option)"
      >
        {{ option.toUpperCase() }}
        <base-tooltip dark @click.native.prevent>
          <PCP-text v-if="option === options.PCP" />
          <HP-text v-if="option === options.HP" />
        </base-tooltip>
      </label>
    </div>
  </div>
</template>

<script>
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import { financeOptions } from "@/constants/financeQuote";
import PCPText from "@/constants/tooltipsTexts/PCPText";
import HPText from "@/constants/tooltipsTexts/HPText";

export default {
  name: "FinanceQuoteRadio",
  components: {
    BaseTooltip,
    PCPText,
    HPText
  },
  props: {
    activeOption: {
      type: String,
      required: true
    },
    disablePCP: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      return financeOptions.availableOptions;
    }
  }
};
</script>

<style lang="scss" scoped>
.finance-quote {
  @include grid-columns(2);
  @include grid-ie11-fix(2);

  &__option {
    display: none;
  }

  &__label {
    padding: 16px 19px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid $color-grey-100;
    background-color: $color-white;
    cursor: pointer;

    &--active {
      background-color: $color-blue-100;
    }

    &--disabled {
      cursor: not-allowed;
      color: $color-grey-300;
      background-color: $color-grey-100;
    }
  }
}

@media screen and (min-width: $media-l) {
  .finance-quote {
    @include flex-basis(40%);

    box-sizing: border-box;
    padding: 0 5px;
  }
}
</style>
